export default {
  current_style: [
    {
      key: 'edgy',
      label: 'Edgy',
      image: 'style_personal_edgy.png'
    },
    {
      key: 'casual',
      label: 'Casual',
      image: 'style_personal_casual.png'
    },
    {
      key: 'sophisticated',
      label: 'Sophisticated',
      image: 'style_personal_sophisticated.png'
    },
    {
      key: 'romantic',
      label: 'Romantic',
      image: 'style_personal_romantic.png'
    },
    {
      key: 'classic',
      label: 'Classic',
      image: 'style_personal_classic.png'
    },
    {
      key: 'boho',
      label: 'Boho',
      image: 'style_personal_boho.png'
    }
  ],
  colors_avoid: [
    {
      key: 'brown',
      color: '#7e5244',
    },
    {
      key: 'black',
      color: '#000000'
    },
    {
      key: 'grey',
      color: '#707070'
    },
    {
      key: 'silver',
      color: '#a6a6a6'
    },
    {
      key: 'white',
      color: '#FFFFFF'
    },
    {
      key: 'red',
      color: '#e30011'
    },
    {
      key: 'orange',
      color: '#ffa100'
    },
    {
      key: 'gold',
      color: '#ffcb00'
    },
    {
      key: 'yellow',
      color: '#fef449'
    },
    {
      key: 'beige',
      color: '#ddb99a'
    },
    {
      key: 'green',
      color: '#67bc40'
    },
    {
      key: 'blue',
      color: '#076ed6'
    },
    {
      key: 'navy',
      color: '#071857'
    },
    {
      key: 'purple',
      color: '#8a00a4'
    },
    {
      key: 'pink',
      color: '#ff0073'
    }
  ],
  patterns_avoid: [
    {
      key: 'stripes',
      label: 'Stripes',
      image: 'style_pattern_stripe.jpg'
    },
    {
      key: 'polka_dots',
      label: 'Polka Dots',
      image: 'style_pattern_polkadot.jpg'
    },
    {
      key: 'animal',
      label: 'Animal',
      image: 'style_pattern_animal.jpg'
    },
    {
      key: 'plaid',
      label: 'Plaid',
      image: 'style_pattern_plaid.jpg'
    },
    {
      key: 'floral',
      label: 'Floral',
      image: 'style_pattern_floral.jpg'
    },
    {
      key: 'abstract',
      label: 'Abstract',
      image: 'style_pattern_abstract.jpg'
    }
  ],
  necklines: [
    {
      key: 'vneck',
      label: 'V-neck',
      image: 'style_neckline_vneck.jpg'
    },
    {
      key: 'ballet',
      label: 'Ballet',
      image: 'style_neckline_ballet.jpg'
    },
    {
      key: 'scoop',
      label: 'Scoop',
      image: 'style_neckline_scoop.jpg'
    },
    {
      key: 'crew',
      label: 'Crew',
      image: 'style_neckline_crew.jpg'
    },
    {
      key: 'turtle',
      label: 'Turtle',
      image: 'style_neckline_turtle.jpg'
    },
    {
      key: 'no_preference',
      label: 'No Preference',
      image: 'style_neckline_nopref.jpg'
    }
  ],
  top_half_fit: [
    {
      key: 'mostly_form_fitting',
      label: 'Mostly Form Fitting',
      image: 'style_top_formfit.jpg'
    },
    {
      key: 'straight',
      label: 'Straight',
      image: 'style_top_straight.jpg'
    },
    {
      key: 'mostly_relaxed',
      label: 'Mostly Relaxed',
      image: 'style_top_relax.jpg'
    },
    {
      key: 'no_preference',
      label: 'No Preference',
      image: 'style_top_nopref.jpg'
    }
  ],
  sleeve_preference: [
    {
      key: 'avoid_sleeveless',
      label: 'Avoid Sleeveless',
      image: 'style_sleeve_short.jpg'
    },
    {
      key: 'show_arms',
      label: 'I Like Showing My Arms',
      image: 'style_sleeve_arm.jpg'
    },
    {
      key: 'no_preference',
      label: 'No Preference',
      image: 'style_sleeve_nopref.jpg'
    }
  ],
  pant_fit: [
    {
      key: 'wide',
      label: 'Wide Leg',
      image: 'style_pant_wide.jpg'
    },
    {
      key: 'skinny',
      label: 'Skinny',
      image: 'style_pant_skinny.jpg'
    },
    {
      key: 'straight',
      label: 'Straight',
      image: 'style_pant_straight.jpg'
    },
    {
      key: 'boyfriend',
      label: 'Boyfriend',
      image: 'style_pant_boyfriend.jpg'
    },
    {
      key: 'flare',
      label: 'Flare',
      image: 'style_pant_flare.jpg'
    },
    {
      key: 'no_preference',
      label: 'No Preference',
      image: 'style_pant_nopref.jpg'
    }
  ],
  dress_style: [
    {
      key: 'shirtdress',
      label: 'Shirtdress',
      image: 'style_dress_shirt.jpg'
    },
    {
      key: 'a_line',
      label: 'A-Line',
      image: 'style_dress_aline.jpg'
    },
    {
      key: 'shift',
      label: 'Shift (Less Fitted)',
      image: 'style_dress_shift.jpg'
    },
    {
      key: 'sheath',
      label: 'Sheath (More Fitted)',
      image: 'style_dress_sheath.jpg'
    },
    {
      key: 'body_con',
      label: 'Body-con',
      image: 'style_dress_bodycon.jpg'
    },
    {
      key: 'swing',
      label: 'Swing',
      image: 'style_dress_swing.jpg'
    },
    {
      key: 'maxi',
      label: 'Maxi',
      image: 'style_dress_maxi.jpg'
    },
    {
      key: 'wrap',
      label: 'Wrap',
      image: 'style_dress_wrap.jpg'
    },
    {
      key: 'no_preference',
      label: 'No Preference',
      image: 'style_dress_nopref.jpg'
    }
  ],
  items_avoid: [
    {
      key: 'crop_tops',
      label: 'Crop Tops',
      image: 'style_avoid_croptop.jpg'
    },
    {
      key: 'cold_shoulders',
      label: 'Cold Shoulders',
      image: 'style_avoid_coldshoulder.jpg'
    },
    {
      key: 'real_fur_or_leather',
      label: 'Real Fur or Leather',
      image: 'style_avoid_fur.jpg'
    },
    {
      key: 'wool',
      label: 'Wool',
      image: 'style_avoid_wool.jpg'
    },
    {
      key: 'silk',
      label: 'Silk',
      image: 'style_avoid_silk.jpg'
    }
  ],
  areas_conceal: [
    {
      key: 'stomach',
      label: 'Stomach',
      image: 'style_conceal_stomach.jpg'
    },
    {
      key: 'arms',
      label: 'Arms',
      image: 'style_conceal_arms.jpg'
    },
    {
      key: 'chest',
      label: 'Chest',
      image: 'style_conceal_chest.jpg'
    },
    {
      key: 'back',
      label: 'Back',
      image: 'style_conceal_back.jpg'
    },
    {
      key: 'waist',
      label: 'Waist',
      image: 'style_conceal_waist.jpg'
    },
    {
      key: 'hips',
      label: 'Hips',
      image: 'style_conceal_hips.jpg'
    },
    {
      key: 'legs',
      label: 'Legs',
      image: 'style_conceal_legs.jpg'
    },
    {
      key: 'none',
      label: 'No Preference',
      image: 'style_conceal_nopref.jpg'
    },
  ],
}